import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { useCustomName } from "hooks"
import { currentUserRole as currentUserRoleSelector } from "reduxSlices/sessionSlice"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import {
  USER_ACCESS_OVERVIEW_TAB_SLUG,
  USER_ACTIONS_TAB_SLUG,
  USER_ATTRIBUTES_TAB_SLUG,
  USER_DEPARTMENTS_TAB_SLUG,
  USER_GENERAL_TAB_SLUG,
  USER_GROUPS_TAB_SLUG,
  USER_HISTORICAL_ACCESS_TOOL_TAB_SLUG,
  USER_SIGN_IN_HISTORY_TAB_SLUG,
  USER_WORKFLOWS_TAB_SLUG,
} from "utils/tabSlugHelpers"
import { PHP_ADMIN_ROLE, SUBMITTER_ROLE } from "utils/userRoleHelpers"
import { SideTabs } from "shared/tabs"
import GeneralTab from "./GeneralTab"
import AccessOverviewTab from "./AccessOverviewTab"
import AttributesTab from "./AttributesTab"
import ActionsTab from "./ActionsTab"
import HistoricalAccessToolTab from "./HistoricalAccessToolTab"
import SignInHistoryTab from "./SignInHistoryTab"
import LocationTab from "./LocationTab"
import GroupsTab from "./GroupsTab"
import UserWorkflowsTab from "./UserWorkflowsTab"

const GENERAL_TAB_TITLE = "General"
const ATTRIBUTES_TAB_TITLE = "Attributes"
const ACCESS_OVERVIEW_TAB_TITLE = "Access Overview"
const HISTORICAL_ACCESS_TOOL_TAB_TITLE = "Historical Access Tool"
const SIGN_IN_HISTORY_TAB_TITLE = "Sign-in History"
const ACTIONS_TAB_TITLE = "Actions"
const GROUPS_TAB_TITLE = "Groups"
const WORKFLOWS_TAB_TITLE = "Workflows"

const SUBMITTER_VISIBLE_TAB_SLUGS = [
  USER_GENERAL_TAB_SLUG,
  USER_ATTRIBUTES_TAB_SLUG,
  USER_SIGN_IN_HISTORY_TAB_SLUG,
]

const TABS = (tabProps, departmentsTabTitle) => [
  {
    title: GENERAL_TAB_TITLE,
    slug: USER_GENERAL_TAB_SLUG,
    TabContent: GeneralTab,
    props: tabProps,
  },
  {
    title: ATTRIBUTES_TAB_TITLE,
    slug: USER_ATTRIBUTES_TAB_SLUG,
    TabContent: AttributesTab,
    props: tabProps,
  },
  {
    title: ACCESS_OVERVIEW_TAB_TITLE,
    slug: USER_ACCESS_OVERVIEW_TAB_SLUG,
    TabContent: AccessOverviewTab,
    props: tabProps,
  },
  {
    title: HISTORICAL_ACCESS_TOOL_TAB_TITLE,
    slug: USER_HISTORICAL_ACCESS_TOOL_TAB_SLUG,
    TabContent: HistoricalAccessToolTab,
    props: tabProps,

  },
  {
    title: SIGN_IN_HISTORY_TAB_TITLE,
    slug: USER_SIGN_IN_HISTORY_TAB_SLUG,
    TabContent: SignInHistoryTab,
    props: tabProps,
  },
  {
    title: ACTIONS_TAB_TITLE,
    slug: USER_ACTIONS_TAB_SLUG,
    TabContent: ActionsTab,
    props: tabProps,
  },
  {
    title: departmentsTabTitle,
    slug: USER_DEPARTMENTS_TAB_SLUG,
    TabContent: LocationTab,
    props: tabProps,
  },
  {
    title: GROUPS_TAB_TITLE,
    slug: USER_GROUPS_TAB_SLUG,
    TabContent: GroupsTab,
    props: tabProps,
  },
  {
    title: WORKFLOWS_TAB_TITLE,
    slug: USER_WORKFLOWS_TAB_SLUG,
    TabContent: UserWorkflowsTab,
    props: tabProps,
  },
]

const UserTabs = ({ tabProps }) => {
  const { user } = tabProps
  const { role: viewedUserRole } = user

  const currentUserRole = useSelector(currentUserRoleSelector)

  const { pluralName: departmentsTabTitle } = useCustomName(DEPARTMENT_KEY)

  let visibleTabs = TABS(tabProps, departmentsTabTitle)

  if (viewedUserRole === SUBMITTER_ROLE) {
    visibleTabs = visibleTabs.filter((tab) => {
      if (!SUBMITTER_VISIBLE_TAB_SLUGS.includes(tab.slug)) {
        return false
      }

      if (tab.slug === USER_SIGN_IN_HISTORY_TAB_SLUG && currentUserRole !== PHP_ADMIN_ROLE) {
        return false
      }

      return true
    })
  }

  return (
    <SideTabs tabs={visibleTabs} />
  )
}

UserTabs.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  tabProps: types.object.isRequired,
}

export default UserTabs
